export default __webpack_public_path__ + "assets/404.6ddcf23842aa398fdb2521ed61e26426.png";